import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/" className="brand" style={{ color: "inherit", textDecoration: "none" }}>
          <span className="brand-mark">SP</span>
          <span>Spieleparadies</span>
        </Link>
        <nav>
          <a
            href="https://gitlab.com/spiele7935721/spieleparadies"
            target="_blank"
            rel="noreferrer"
            className="btn btn-ghost"
          >
            GitLab
          </a>
        </nav>
      </header>
      <main className="app-main">{children}</main>
      <footer className="app-footer">
        Made with ♥ – Spieleparadies · Multiplayer Mini-Games
      </footer>
    </div>
  );
}
